import styled from 'styled-components';
import { color, border, space, fontSize, height } from 'styled-system';

const TextArea = styled.textarea`
  appearance: input;
  display: block;
  width: 100%;
  margin: 0;
  resize: none;
  outline:none;

  border: 0;
  box-shadow: inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1), inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15);

  &:focus {
    box-shadow: inset 0px 3px 5px 0px rgba(16, 107, 87, 0.1), inset 0px 0px 0px 2px rgba(16, 107, 87, 0.25);
    border-radius: 4px;
  }

  ${height}
  ${border}
  ${space}
  ${fontSize}
  ${color}
`;

TextArea.displayName = 'Input';
TextArea.propTypes = {
  ...color.propTypes,
  ...space.propTypes
};

TextArea.defaultProps = {
  color: 'primary',
  bg: 'white',
  fontSize: 2,
  borderRadius: 4,
  p: 4,
  mb: 2,
  rows: 100,
  cols: 20
};

export default TextArea;
